// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2ETnF","colMaxWidth":"Table_colMaxWidth__1P-9g"};